import React from 'react';
import PropTypes from 'prop-types';
import LocaleLink from '@components/LocaleLink';
import { Text } from '@custom-components';
import { LinkButton, SecondaryNavContainer } from './SecondaryNav.styles';
import { SECONDARY_NAV_LINKS } from '../../../../layouts/DefaultLayout/MainNavContainer/secondaryNavigationConfig';

function SecondaryNav(props) {
  const { routeName } = props;
  const secondaryNav = SECONDARY_NAV_LINKS.find(({ routeMatches = [] }) => routeMatches.includes(routeName)) ?? {};
  const { routes } = secondaryNav;
  if (!secondaryNav || !routes) return null;

  return (
    <SecondaryNavContainer>
      {routes?.map((item) => {
        const { route, label, routeMatches } = item;
        const isSelected = routeMatches.includes(routeName);
        return (
          <LocaleLink route={route} passHref key={label}>
            <LinkButton style={{ margin: '0px 8px' }}>
              <Text.CopyBody color={isSelected ? 'quaternary' : 'primary'} noMargins>
                {label.defaultMessage?.[0]?.value}
              </Text.CopyBody>
            </LinkButton>
          </LocaleLink>
        );
      })}
    </SecondaryNavContainer>
  );
}
SecondaryNav.propTypes = {
  mainNav: PropTypes.shape({
    subMenuLinks: PropTypes.arrayOf({})
  }),
  routeName: PropTypes.string
};
SecondaryNav.defaultProps = {
  mainNav: {},
  routeName: ''
};

export default SecondaryNav;
